
import { Module } from '../core';

export default class ModuleMeasurement extends Module {

    constructor() {
        super('measurement');
    }

    addCommands(mapCommander) {
        // nop;
    }

    initOpenLayersMap(params) {
        // nop;
    }
}
